// do tp
export const typeOptionsDoTp = [
  {
    id: 1,
    boxId: 'red',
    label: 'TOUT',
    value: "MDI_DO','MDI_PR,TP",
    name: 'typeDoTp',
    automatedTestId: 'dropdown-superieur',
  },
  {
    id: 2,
    boxId: 'orange',
    label: 'DO',
    value: 'MDI_DO',
    name: 'typeDoTp',
    automatedTestId: 'dropdown-inferieur',
  },
  {
    id: 3,
    boxId: 'blue',
    label: 'TP',
    value: 'MDI_PR,TP',
    name: 'typeDoTp',
    automatedTestId: 'dropdown-inter',
  },
];

// MILIEU
export const typeOptionsMilieuSensibility = [
  {
    id: 1,
    boxId: 'red',
    label: 'TOUT',
    value: "MDI_DO', 'MDI_PR', 'MDI_PR,TP', 'MDI_SE",
    name: 'typeMilieu',
  },
  {
    id: 2,
    boxId: 'orange',
    label: 'DO',
    value: 'MDI_DO',
    name: 'typeMilieu',
  },
  {
    id: 3,
    boxId: 'blue',
    label: 'PR',
    value: 'MDI_PR',
    name: 'typeMilieu',
  },
  {
    id: 4,
    boxId: 'green',
    label: 'STEP',
    value: 'MDI_SE',
    name: 'typeMilieu',
  },
  {
    id: 5,
    boxId: 'grey',
    label: 'TP',
    value: 'MDI_PR,TP',
    name: 'typeMilieu',
  },
];

export const typeOptionsMilieuDilution = [
  // {
  //   id: 1,
  //   boxId: 'red',
  //   label: 'TOUT',
  //   value: "MDI_DO', 'MDI_PR', 'MDI_SE",
  //   name: 'typeMilieu',
  // },
  // {
  //   id: 2,
  //   boxId: 'orange',
  //   label: 'DO',
  //   value: 'MDI_DO',
  //   name: 'typeMilieu',
  // },
  // {
  //   id: 3,
  //   boxId: 'blue',
  //   label: 'STEP',
  //   value: 'MDI_SE',
  //   name: 'typeMilieu',
  // },
  // {
  //   id: 4,
  //   boxId: 'green',
  //   label: 'TP',
  //   value: 'MDI_PR,TP',
  //   name: 'typeMilieu',
  // },
  {
    id: 1,
    boxId: 'red',
    label: 'STEP',
    value: 'MDI_SE',
    name: 'typeMilieuDilution',
  },
];

// INDUS
export const domesticOptionsIndus = [
  {
    id: 1,
    name: 'Non',
    code: 0,
    automatedTestId: 'dropdown-non',
  },
  {
    id: 2,
    name: 'Oui',
    code: 1,
    automatedTestId: 'dropdown-oui',
  },
  {
    id: 3,
    name: 'Toutes',
    code: '',
    automatedTestId: 'dropdown-tout',
  },
];

// PR MR
export const criticityOptionsPrMr = [
  {
    id: 1,
    name: 'Non Critique',
    code: 'NC',
    automatedTestId: 'dropdown-non-critique',
  },
  {
    id: 2,
    name: 'Critique',
    code: 'C',
    automatedTestId: 'dropdown-critique',
  },
  {
    id: 3,
    name: 'Très critique',
    code: 'TC',
    automatedTestId: 'dropdown-tres-critique',
  },
  {
    id: 4,
    name: 'Criticité non renseignée',
    code: 'SC',
    automatedTestId: 'dropdown-critique-inconnu',
  },
  {
    id: 5,
    name: 'Toutes',
    code: '',
    automatedTestId: 'dropdown-tout-critique',
  },
];

// pluie
export const typeOptionsPluie = [
  {
    id: 1,
    boxId: 'red',
    label: 'TOUT',
    value: "MDI_DO','MDI_PR,TP",
    name: 'typePluie',
    automatedTestId: 'dropdown-pluie-tout',
  },
  {
    id: 2,
    boxId: 'orange',
    label: 'DO',
    value: 'MDI_DO',
    name: 'typePluie',
    automatedTestId: 'dropdown-pluie-do',
  },
  {
    id: 3,
    boxId: 'blue',
    label: 'TP',
    value: 'MDI_PR,TP',
    name: 'typePluie',
    automatedTestId: 'dropdown-pluie-tp',
  },
];